import { render, staticRenderFns } from "./problem-record-add-or-update.vue?vue&type=template&id=24a91dc6&scoped=true&"
import script from "./problem-record-add-or-update.vue?vue&type=script&lang=js&"
export * from "./problem-record-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./problem-record-add-or-update.vue?vue&type=style&index=0&id=24a91dc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a91dc6",
  null
  
)

export default component.exports